export const TicketType = {
    VDO: 'VDO',
    VIR: 'VIR',
    RTE: 'RTE',
    RTEDR: 'RTEDR'
}